import { apiService } from "@base/configs";
import httpService from "@base/services/httpService";
import { IDrService } from "./interface/drService.interface";

class DrServiceService {
  // get list
  getList(lang: string, online?: boolean, specialization_code?: string, siteCode?: string) {
    return httpService.get<IDrService[]>(`${apiService.doctor.drService.getList}`, {
      params: { lang, online, specialization_code, siteCode },
    });
  }

  /** The services a clinic offers for one kind of booking. Note the camelCase `siteCode`. */
  getListForBooking(params: { online: boolean; siteCode: string; specialization_code: string; lang: string; site_branch_code?: string }) {
    return httpService.get<IDrService[]>(`${apiService.doctor.drService.getList}`, { params });
  }

  // get by id
  getById(id: string | number, lang: string) {
    return httpService.get<IDrService>(`${apiService.doctor.drService.getById}/${id}/${lang}`);
  }
}

export default new DrServiceService();
